module.exports = __webpack_public_path__ + "static/media/Gucci-Dionysus_thumb.55426f60.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/bags/Gucci-Dionysus_thumb.png
// module id = 220
// module chunks = 0